'use client';
import { useEffect, useState } from 'react';
import { getMessaging, getToken } from 'firebase/messaging';
import firebaseApp from '@/lib/utils/firebase';
import { storage_keys } from '@/constant/configs';
import { checkFireabseBrowserSupport } from '@/lib/helpers/functions';

const useFcmToken = () => {
  const [fcmToken, setFcmToken] = useState('');
  const [notificationPermissionStatus, setNotificationPermissionStatus] =
    useState('');

  useEffect(() => {
    const retrieveToken = async () => {
      try {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log(registration.scope);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });

        let messaging: any;
        if (firebaseApp) {
          messaging = getMessaging(firebaseApp);
        }

        // Request notification permission
        const permission = await Notification.requestPermission();
        setNotificationPermissionStatus(permission);

        if (permission === 'granted' && messaging) {
          const deviceToken = await getToken(messaging, {
            vapidKey: process.env.NEXT_PUBLIC_FIREBASE_WEB_KEY, // Replace with your Firebase project's VAPID key
          });

          if (deviceToken) {
            setFcmToken(deviceToken);
            localStorage.setItem(
              storage_keys.firebase_device_token,
              deviceToken
            );
          } else {
            console.error(
              'No registration token available. Request permission to generate one.'
            );
          }
        }
      } catch (error) {
        console.error('Error retrieving token:', error);
      }
    };

    if (checkFireabseBrowserSupport()) {
      retrieveToken();
    }
  }, []);

  return { fcmToken, notificationPermissionStatus, firebaseApp };
};

export default useFcmToken;
